var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',{staticClass:"main"},[_c('v-container',{attrs:{"fluid":""}},[_c('div',{staticClass:"main-content"},[_c('transition',{attrs:{"name":"slide","mode":"out-in"}},[_c('router-view')],1)],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }